import {Component, OnInit} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { downgradeComponent } from '@angular/upgrade/static';

import { ApiService, AuthService } from "../core/upgraded-providers";

declare const angular: angular.IAngularStatic;

@Component({
    templateUrl: './report-problem.component.pug',
})
export class ReportProblemComponent implements OnInit {

    serverError = null;
    submitted = false;
    private form: FormGroup;

    constructor(
        private authService: AuthService,
        private apiService: ApiService,
        private formBuilder: FormBuilder,
    ) {
        this.form = this.createForm();
    }

    private createForm() {
        return this.formBuilder.group({
            email: new FormControl(''),
            urgent: new FormControl(false),
            subject: new FormControl(''),
            description: new FormControl(''),
            versionDetails: new FormControl(''),
        });
    }

    ngOnInit(): void {
        if(this.authService.Me) {
            this.form.patchValue({ email: this.authService.Me.email });
        }
    }

    async onSubmit() {
        const { valid, value } = this.form;
        if (valid) {
            try {
                await this.apiService.post('zendesk/report-problem', value);
                this.submitted = true;
            } catch (err) {
                console.warn(err);
                this.serverError = err.message || err;
            }
        }
    }
}

angular.module('app').directive('app2ReportProblem',
    downgradeComponent({component: ReportProblemComponent}));
